/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { RecordingsStatusByStationId } from 'client-code/recordings-status';

import { RecordingsStatusServiceRepositoryImpl } from '../impls';
import { IRecordingsStatusService, IRecordingsStatusServiceRepository } from '../interfaces';
import { TRecordingsStatusDetails, TServicesParams } from '../types';

export class RecordingsStatusService implements IRecordingsStatusService {
    private readonly oRecordingsStatusServiceRepository: IRecordingsStatusServiceRepository;

    public constructor(params: TServicesParams) {
        this.oRecordingsStatusServiceRepository = new RecordingsStatusServiceRepositoryImpl(params);
    }

    /**
     * @inheritdoc
     */
    public async getRecordingsStatus(): Promise<RecordingsStatusByStationId[]> {
        return (await this.oRecordingsStatusServiceRepository.fetchRecordingsStatus())
            .recordingsStatus;
    }

    /**
     * @inheritdoc
     */
    public async getRecordingsStatusDetails(): Promise<TRecordingsStatusDetails> {
        return this.oRecordingsStatusServiceRepository.fetchRecordingsStatus();
    }
}
